/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Tab_OverviewInputs */

const en_case_detail_tab_overview = /** @type {(inputs: Case_Detail_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const pt_br2_case_detail_tab_overview = /** @type {(inputs: Case_Detail_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Case_Detail_Tab_OverviewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_tab_overview = /** @type {((inputs?: Case_Detail_Tab_OverviewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Tab_OverviewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_tab_overview(inputs)
	return pt_br2_case_detail_tab_overview(inputs)
});